import React, { useState, useEffect } from 'react'
import { Col, Icon, Panel, Row } from 'rsuite'
import { NOT_SPECIFIED_MSG } from '../../constants/msgText'

export default function ProjectMonitorRecordViewWidgets({ schema }) {
  const renderInnerInput = (item, tabRight) => {
    let inputObj

    switch (item.type) {
      case 'INPUT':
        inputObj = (
          <div style={{ marginTop: 10, wordWrap: 'break-word' }}>
            {item.label} : <b>{item.value || NOT_SPECIFIED_MSG}</b>
          </div>
        )
        break
      case 'INPUT_NUMBER':
        inputObj = (
          <div style={{ marginTop: 10, wordWrap: 'break-word' }}>
            {item.label} : <b>{item.value || NOT_SPECIFIED_MSG}</b> {item.postLabel || ''}
          </div>
        )
        break
      case 'INPUT_AREA':
        inputObj = (
          <div style={{ marginTop: 10, wordWrap: 'break-word' }}>
            {item.label ? <label>{item.label} :</label> : ''}
            <div
              style={{ marginTop: 10, fontWeight: 'bold', marginLeft: 10 }}
              dangerouslySetInnerHTML={{ __html: item.value || NOT_SPECIFIED_MSG }}
            />
          </div>
        )
        break
      case 'CHECKBOX':
        inputObj = (
          <div style={{ marginTop: 10 }}>
            <Icon size="lg" icon={item.value ? 'check-square-o' : 'square-o'} />{' '}
            <label style={{ marginLeft: 10 }}>{item.label}</label>
          </div>
        )
        break
      case 'RADIO':
        inputObj = (
          <div>
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              {item.isBolder ? <strong>{item.label}</strong> : item.label}
            </div>

            {item.inputOptions?.map((op) => {
              if (item.inline) {
                return (
                  <label style={{ marginLeft: 20 }}>
                    <Icon size="lg" icon={op.value == item.value ? 'check-square-o' : 'square-o'} />{' '}
                    <label style={{ marginLeft: 10 }}>{op.label}</label>
                    {
                      //op.value == objectsValues?.get(item.id) &&
                      op?.moreInputs?.map((e) => {
                        return renderInnerInput(e, true)
                      })
                    }
                  </label>
                )
              } else {
                return (
                  <div style={{ marginLeft: 20, marginBottom: 10 }}>
                    <Icon size="lg" icon={op.value == item.value ? 'check-square-o' : 'square-o'} />{' '}
                    <label style={{ marginLeft: 10 }}>{op.label}</label>
                    {
                      //op.value == objectsValues?.get(item.id) &&
                      op?.moreInputs?.map((e) => {
                        return renderInnerInput(e, true)
                      })
                    }
                  </div>
                )
              }
            })}
          </div>
        )
        break
      case 'DOPDOWN':
        inputObj = (
          <div style={{ marginTop: 10 }}>
            {item.label ? <label>{item.label} :</label> : ''}
            <b style={{ marginLeft: 20 }}>
              {item.valueDef ||
                item?.options?.find((e) => e.value == item.value)?.label ||
                NOT_SPECIFIED_MSG}
            </b>
          </div>
        )
        break
      case 'LABEL':
        inputObj = (
          <div style={{ marginTop: 10 }}>
            {item.isBolder ? <strong>{item.label}</strong> : item.label}
          </div>
        )
        break
      default:
        break
    }

    return (
      <>
        <Row style={{ marginLeft: tabRight ? 40 : undefined }}>
          <Col xs={24} sm={24} md={24} lg={24}>
            {inputObj}

            {item.moreInputs?.map((subItem) => {
              return renderInnerInput(subItem, true)
            })}
          </Col>
        </Row>
      </>
    )
  }

  const renderInputs = (datas, tabRight) => {
    return (
      <>
        {datas?.map((item, index) => {
          return (
            <Row style={{ marginLeft: tabRight ? 20 : undefined }}>
              <Col xs={24} sm={24} md={24} lg={24}>
                <>{renderInnerInput(item, false)}</>
                {item.childs && renderInputs(item.childs, true)}
              </Col>
            </Row>
          )
        })}
      </>
    )
  }

  return (
    <>
      <Panel
        style={{ marginBottom: 10, marginTop: 10 }}
        header={schema.header}
        collapsible
        defaultExpanded
        bordered
      >
        <div style={{ marginTop: -10 }}>
          {schema.detail}
          {renderInputs(schema.values)}
        </div>
      </Panel>
    </>
  )
}
